<script setup>
</script>

<template>
  <section>
    <img src="/images/fondo.jpg" alt="">
  </section>
</template>

<style scoped lang="scss">
section {
  height: unset;
  min-height: unset;

  position: sticky;
  top: 0;

}

img {
  width: 100%;
  height: calc(100vh - var(--header-height));
  object-fit: cover;
}
</style>